/**
 * SelectList function that allows users to select a referential version.
 *
 * @param {Object} props - The function props.
 * @param {Function} props.setReferentiel - Function to set the selected referential key.
 * @param {Function} props.setRefVersion - Function to set the selected referential version.
 *
 * @returns {JSX.Element} The rendered function.
 *
 * @function
 *
 * @example
 * return (
 *   <SelectList setReferentiel={setReferentiel} setRefVersion={setRefVersion} />
 * )
 *
 * @remarks
 * This function uses the `StoreRef` and `StoreRefVersion` hooks to fetch and filter referential data.
 * It displays a list of referential versions using the `ListSelection` function.
 * The selected referential and version are updated based on user interaction.
 */

import { useEffect, useState } from 'react';
import { StoreRef, StoreRefVersion } from '../../hooks/store';
import ListSelection from '@front-ends/common/src/components/app/ListSelection';
import { SelectChangeEvent } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function SelectList({setReferentiel, setRefVersion, setFilterType}:any) {

  const { t } = useTranslation();

  const [refDisplay, setRefDisplay] = useState('');
  const {search, response, isLoading} = StoreRef();
  let filteredResponse = response?.filter((result) => result.key === 'TAXREF' || result.key === 'GBIF_BBT');
  const {find, refResult} = StoreRefVersion();

  useEffect(() => {
		search();
  }, []);;

  useEffect(() => {
    if (/TAXREF/i.test(refDisplay)) { // TODO : Modifier le filtre 'FRANCE' en 'ALL_TAXA' si le filtre est push sur les Référentiels
      setFilterType('FRANCE');
      //setFilterType('ALL_TAXA');
      find('TAXREF');
    } else if (/GBIF/i.test(refDisplay)) {
      setFilterType('GBIF_BBT');
      find('GBIF_BBT');
    }
  }, [refDisplay]);

  useEffect(() => {
    if (refResult) {
      setReferentiel(refResult?.key);
      setRefVersion(refResult?.version);
    }
  }, [refResult]);

  if (isLoading && !response) {
    return null
  }

  function handleChange (event: SelectChangeEvent) {
    setRefDisplay(event.target.value as string);
    StoreRef.setState({isFinished: true});
  }

  return (
    <div>
      <ListSelection 
        resultList={filteredResponse}
        display={refDisplay}
        label={t('ref-context')}
        setDisplayLabel={setRefDisplay}
        handleChange={handleChange}
      />
    </div>
  );
}